
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "TextBlock",

  computed: {
    isTwoColumns: function () {
      return Boolean(this.cfgs?.message_two_columns)
    }
  }
});
